
(function($) {

    const AjaxToggle = function(element, options) {
        this.element = element;
        this.element.on('change', $.proxy(this.onChange, this));

        this.url = options.url || this.element.attr('data-url');
        this.paramName = options.paramName || this.element.attr('data-param-name');
        this.token = options.token || this.element.attr('data-token');
    };

    AjaxToggle.prototype.onChange = function(event) {
        const data = {};
        data[this.paramName] = {
            _token: this.token
        };

        if (this.element.prop('checked')) {
            data[this.paramName].active = 1;
        }

        $.ajax({
            url: this.url,
            method: 'POST',
            dataType: 'json',
            data: data,
            success: (response) => {
                Notifications.messages(response.messages);
            },
            error: () => {
                this.element.prop('checked', !this.element.prop('checked'));
            }
        })
    };

    const AjaxTogglePlugin = function(options) {
        return $.each(this, function () {
            var element = $(this),
                data = element.data('ajaxToggle');

            if (!data) {
                data = new AjaxToggle(element, options);
                element.data('ajaxToggle', data);
            }
        })
    };

    $.fn.ajaxToggle = AjaxTogglePlugin;

})(jQuery);


// WEBPACK FOOTER //
// ./js/form/ajaxToggle.js